import { render } from "./upload-avatar-form.vue?vue&type=template&id=6aea21c7&ts=true"
import script from "./upload-avatar-form.vue?vue&type=script&lang=ts"
export * from "./upload-avatar-form.vue?vue&type=script&lang=ts"

import "./upload-avatar-form.vue?vue&type=style&index=0&id=6aea21c7&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__